export enum OrganizationConnectionType {
  CloudBillingSync = 1,
  Scim = 2,
}
